"use client";

import { useEffect } from "react";
import { useTheme } from "next-themes";

/** Тёмная тема: с 18:00 до 08:00 по локальному времени пользователя. */
const DARK_START_HOUR = 18;
const DARK_END_HOUR = 8;

function getScheduledTheme(): "dark" | "light" {
  const hour = new Date().getHours();
  if (hour >= DARK_START_HOUR || hour < DARK_END_HOUR) return "dark";
  return "light";
}

export function ThemeSchedule() {
  const { setTheme } = useTheme();

  useEffect(() => {
    const apply = () => {
      const next = getScheduledTheme();
      setTheme(next);
    };
    apply();
    const interval = setInterval(apply, 60 * 1000);
    return () => clearInterval(interval);
  }, [setTheme]);

  return null;
}
